/**
 * @memberOf loavies.utils.services
 * @typedef {ImageCacheService}
 * @alias this.$imageCacheService
 */
export class ImageCacheService {
  #debounce
  #cachedImages = {}
  #storage
  #storageKey = 'cachedImages'

  constructor(storage = sessionStorage) {
    this.#storage = storage

    try {
      const storageString = this.#storage.getItem(this.#storageKey)

      if (storageString) {
        this.#cachedImages = JSON.parse(storageString)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  /**
   * @param {string} imageSrc
   * @return {void}
   */
  addToCache(imageSrc) {
    if (!this.isInCache(imageSrc)) {
      this.#cachedImages[imageSrc] = true
      this.#updateImagesToStorage()
    }
  }

  /**
   * @param {string} imageSrc
   * @return {boolean}
   */
  isInCache(imageSrc) {
    return this.#cachedImages[imageSrc] || false
  }

  /**
   * @return {void}
   */
  #updateImagesToStorage() {
    clearTimeout(this.#debounce)

    this.#debounce = setTimeout(() => {
      try {
        this.#storage.setItem(this.#storageKey, JSON.stringify(this.#cachedImages))
        clearTimeout(this.#debounce)
      } catch (error) {
        console.warn(error)
      }
    }, 1000)
  }
}
